<section class="prediction-legend" aria-label="Prediction legend">
  <button
    type="button"
    class="legend-header"
    [attr.aria-expanded]="!collapsed"
    aria-label="Toggle prediction legend"
    (click)="toggleLegend()"
  >
    <span>Legend</span>
    <span class="material-icons-outlined legend-chevron" [class.legend-chevron--collapsed]="collapsed">
      expand_less
    </span>
  </button>

  <div class="legend-body" *ngIf="!collapsed">
    <section
      class="detection-group"
      *ngFor="let group of groups; trackBy: trackGroup"
    >
      <button
        type="button"
        class="detection-header"
        [attr.aria-expanded]="isExpanded(group)"
        [attr.aria-label]="'Toggle ' + group.label + ' forecasts'"
        (click)="toggleGroup(group)"
      >
        <span class="legend-swatch" [style.background-color]="group.color"></span>
        <span class="detection-name">{{ group.label }}</span>
        <span
          *ngIf="group.forecasts.length"
          class="material-icons-outlined group-chevron"
          [class.group-chevron--collapsed]="!isExpanded(group)"
        >
          expand_less
        </span>
      </button>

      <div class="forecast-row" *ngIf="group.forecasts.length && isExpanded(group)">
        <span class="forecast-label">Forecast</span>
        <div class="forecast-items">
          <span
            class="forecast-item"
            *ngFor="let forecast of group.forecasts; trackBy: trackForecast"
            [attr.title]="'Forecast at +' + forecast.hour + ' hours'"
            (mouseenter)="legendHoveredHour = forecast.hour"
            (mouseleave)="legendHoveredHour = null"
          >
            <span class="legend-swatch legend-swatch--forecast" [style.background-color]="forecast.color"></span>
            <span>{{ forecast.hour }}h</span>
          </span>
        </div>
      </div>
      <div
        class="forecast-area"
        *ngIf="isExpanded(group) && hoveredForecast(group) as forecast"
      >
        Total area ({{ forecast.hour }}h): {{ forecast.area }}
      </div>
    </section>

    <ng-container *ngFor="let extraGroup of extraGroups; let groupIndex = index; trackBy: trackExtraGroup">
      <button
        *ngIf="extraGroup.header"
        type="button"
        class="extra-feed-line extra-feed-header"
        [ngStyle]="extraGroup.header.style"
        [attr.aria-expanded]="extraGroup.items.length ? isExtraGroupExpanded(groupIndex) : null"
        [disabled]="!extraGroup.items.length"
        (click)="toggleExtraGroup(groupIndex)"
      >
        <span class="extra-feed-text">
          <b>{{ extraGroup.header.text }}</b>
          <span *ngIf="extraGroup.header.subText" class="extra-feed-subtext">{{ extraGroup.header.subText }}</span>
        </span>
        <span
          *ngIf="extraGroup.items.length"
          class="material-icons-outlined group-chevron"
          [class.group-chevron--collapsed]="!isExtraGroupExpanded(groupIndex)"
        >
          expand_less
        </span>
      </button>

      <ng-container *ngIf="!extraGroup.header || isExtraGroupExpanded(groupIndex)">
        <div
          class="extra-feed-line"
          *ngFor="let item of extraGroup.items; trackBy: trackExtraItem"
          [ngStyle]="item.style"
        >
          <span
            *ngIf="item.legendColor"
            class="legend-swatch extra-feed-swatch"
            [style.background-color]="item.legendColor"
          ></span>
          <span class="extra-feed-text">
            <b>{{ item.text }}</b>
            <span *ngIf="item.subText" class="extra-feed-subtext">{{ item.subText }}</span>
          </span>
        </div>
      </ng-container>
    </ng-container>
  </div>
</section>
